export const hotkeysConfig = {
    seekStep: 10,
    enableModifiersForNumbers: false,
    enableHoverScroll: true,
    playPauseKey: (event, player) => {
        return event.which === 32 && player.settings().enablePlayPause;
    },
    rewindKey: (event, player) => {
        return event.which === 37 && player.settings().enableSeeking && !event.shiftKey;
    },
    forwardKey: (event, player) => {
        return event.which === 39 && player.settings().enableSeeking && !event.shiftKey;
    },
    fullscreenKey: (event, player) => {
        return event.which === 70 && player.settings().enableFullScreen;
    },
    //if any of these are updated, make sure the 'modifyControlText' function in the player is updated accordingly
    customKeys: {
        questionKey: setupCustomKey("q", "askAQuestion", "openModal"),
        toggleCaptionsKey: setupCustomKey("c", "captions", "toggleCaptions"),
        toggleChapterssKey: setupCustomKey("C", "chapters", "toggleChaptersButton"),        
        searchKey: setupCustomKey("s", "search", "openModal"),
        infoKey: setupCustomKey("i", "metadata", "openModal"),
        shareKey: setupCustomKey("e", "share", "openModal"),
        helpKey: setupCustomKey("h", "help", "handleClick"),
        downloadKey: setupCustomKey("d", "downloads", "openModal"),
        pollsKey: setupCustomKey("p", "polls", "open"),
        nextPresentationKey: setupCustomKey(">", "playlist", "simulateNextBtnClick"),
        prevPresentationKey: setupCustomKey("<", "playlist", "simulatePrevBtnClick"),
        homePresentationKey: setupCustomKey("?", "playlist", "simulateHomeBtnClick"),
        arrowKeyShift: {
            key: event => event.which === 39 || event.which === 37,
            handler: (player, options, event) => {
                if (player.settings().enableSeeking) {
                    //Skip Back 1 second
                    if (event.which === 37 && event.shiftKey) {
                        player.currentTime(player.currentTime() - 1);
                    }

                    //Skip Forward 1 second
                    if (event.which === 39 && event.shiftKey) {
                        player.currentTime(player.currentTime() + 1);
                    }
                }
            }
        },
        audioKey: {
            key: event => event.key === 'a',
            handler: (player, options, event) => {
                const audioBtn = player.getDescendant('ControlBar', 'AudioTrackButton');
                if (audioBtn) {
                    audioBtn.pressButton();
                }
            }
        },
        playbackKey: {
            key: event => event.key === 'r',
            handler: (player, options, event) => {
                const playbackBtn = player.getDescendant('ControlBar', 'PlaybackRateMenuButton');
                if (playbackBtn) {
                    playbackBtn.pressButton();
                }
            }
        },
        captionSettingsKey: {
            key: event => event.key === 'v',
            handler: (player, options, event) => {
                //TextTrackSettings is video.js's name for the Caption Settings modal
                const captionsModal = player.getChild("TextTrackSettings");
                if (captionsModal) {
                    const captionsPlugin = player.captions();
                    //visible instead of enabled due to enabled always being set to true on construction
                    if (captionsPlugin.visible) {
                        captionsModal.open();
                    }
                }
            }
        },
        swapStreamsKey: {
            key: event => event.key === '.',
            handler: (player, options, event) => {
                const swapBtn = player.getDescendant('ControlBar', 'SwapStreamsButton');
                if (swapBtn && player.settings()?.enableSwapStreams) {
                    swapBtn.options_.clickHandler.call(swapBtn, options, event);
                }
            }
        },
        lockControlsKey: {
            key: event => event.key === 'l',
            handler: (player, options, event) => {
                const ctrlsLockBtn = player.getDescendant('ControlBar', 'ControlsLockButton');
                if (ctrlsLockBtn) {
                    ctrlsLockBtn.options_.clickHandler.call(ctrlsLockBtn);
                }
            }
        }
    }
};

/*
 * A generic function for setting up the custom keys
 * A capitalized letter means that the user should also press 'shift'
 */ 
function setupCustomKey(targetKey, plugin, functionToCall) {
    return {
        key: event => event.key === targetKey,
        handler: (player, options, event) => {
            //checks if the plugin requested does exist before trying to get the plugin and call the corresponding function
            let playerPlugin = player[plugin];
            if (playerPlugin) {
                playerPlugin()[functionToCall]();
            }
        }
    }
}